define('presentation/settings/callQueues/validators/callQueuePoolViewModelValidator',[
    'common/promises/promiseFactory',
    'presentation/common/routeToModal/common/routeToValidationHelper',
    'presentation/common/validation/validationRule',
    'presentation/common/validation/commonValidator',
], function() {
    return function() {
        const self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const RouteToValidationHelperConstructor = require('presentation/common/routeToModal/common/routeToValidationHelper');
        const _validationHelper = new RouteToValidationHelperConstructor();

        const CommonValidatorConstructor = require('presentation/common/validation/commonValidator');
        const ValidationRulesConstructor = require('presentation/common/validation/validationRule');

        const MINIMUM_MAX_CALLERS_IN_QUEUE = 1;
        const MAXIMUM_MAX_CALLERS_IN_QUEUE = 250;
        const MINIMUM_MAX_WAIT_SECONDS = 1;
        const MAXIMUM_MAX_WAIT_SECONDS = 3600;
        const MINIMUM_MAX_CONCURRENT_DESTINATION_CALLS = 1;
        const MAXIMUM_MAX_CONCURRENT_DESTINATION_CALLS = 250;

        let _commonValidator = null;
        let _pools;
        let _viewModel;

        self.registerViewModel = (viewModel, pools) => {
            _viewModel = viewModel;
            _pools = pools;

            let validationRules = new ValidationRulesConstructor();
            validationRules.field('poolName')
                .addValidationI18n(_poolNameMustBeProvided, 'addCallQueue:poolNameRequired')
                .addValidationI18n(_poolNameIsUnique, 'addCallQueue:poolNameMustBeUnique');
            validationRules.field('maxCallersInQueue')
                .addValidationI18n(_isMaxCallersInQueueValid, 'addCallQueue:maxCallersInQueueInvalid');
            validationRules.field('maxWaitSeconds')
                .addValidationI18n(_isMaxWaitSecondsValid, 'addCallQueue:maxWaitSecondsInvalid');
            validationRules.field('maxConcurrentDestinationCalls')
                .addValidationI18n(_isMaxConcurrentDestinationCallsValid, 'addCallQueue:maxConcurrentDestinationCallsInvalid');
            validationRules.field('isRoutingRuleValid')
                .addValidationI18n(_isRoutingRuleValid, 'addCallQueue:routingRuleError');

            _commonValidator = new CommonValidatorConstructor(_viewModel, validationRules, true);
        };

        const _poolNameMustBeProvided = (poolName) => _commonValidator.isStringWithValue(poolName);

        const _poolNameIsUnique = () => _commonValidator.isUnique(_viewModel, _pools, "sequence", "poolName");

        const _isMaxCallersInQueueValid = (maxCallersInQueue) => {
            return _commonValidator.isNumberBetweenValues(maxCallersInQueue, MINIMUM_MAX_CALLERS_IN_QUEUE, MAXIMUM_MAX_CALLERS_IN_QUEUE);
        };

        const _isMaxWaitSecondsValid = (maxWaitSeconds) => {
            return _commonValidator.isNumberBetweenValues(maxWaitSeconds, MINIMUM_MAX_WAIT_SECONDS, MAXIMUM_MAX_WAIT_SECONDS);
        };

        const _isMaxConcurrentDestinationCallsValid = (maxConcurrentDestinationCalls) => {
            return _commonValidator.isNumberBetweenValues(maxConcurrentDestinationCalls, MINIMUM_MAX_CONCURRENT_DESTINATION_CALLS, MAXIMUM_MAX_CONCURRENT_DESTINATION_CALLS);
        };

        const _isRoutingRuleValid = () => {
            return _promiseFactory.defer((deferredObject) => {
                _validationHelper.validateRouteToViewModel(_viewModel.routeToViewModel())
                    .done((result) => {
                        deferredObject.resolve(result);
                    });
            });
        };

        self.validate = () => {
            return _commonValidator.validate();
        };
    };
});

